var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('InfoAlert',{attrs:{"showDismissibleAlert":_vm.showDismissibleAlert,"info":_vm.info},on:{"close":function($event){_vm.showDismissibleAlert = false}}}),(_vm.dbData && _vm.dbData.length > 0)?_c('div',[_c('v-simple-table',{style:({
        'background-color':
          _vm.$store.getters.getColorPalette().background2ColorCode,
        color: _vm.$store.getters.getColorPalette().accentCode,
      }),attrs:{"color":_vm.$store.getters.getColorPalette().backgroundColorName,"fixed-header":"","dense":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',{style:({
            'background-color':
              _vm.$store.getters.getColorPalette().background2ColorCode,
            color: _vm.$store.getters.getColorPalette().accentCode,
          })},[_c('tr',[_c('th',{class:' text-center  text-subtitle-1 text-capitalize ',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_vm._v(" "+_vm._s(_vm.headerMap[_vm.timeFilter] ? _vm.headerMap[_vm.timeFilter] : _vm.headerMap["month"])+" ")]),_vm._l((_vm.headers),function(item,ind){return _c('th',{key:ind,class:' text-center  text-subtitle-1 text-capitalize ',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.getSeverityColorClass(item),
              })},[_vm._v(" "+_vm._s(item)+" ")])}),_vm._l((_vm.headers2),function(item,ind){return _c('th',{key:ind + item,class:' text-center  text-subtitle-1 text-capitalize ',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color:
                  item === '% of Compliances'
                    ? '#29B6F6'
                    : _vm.$store.getters.getColorPalette().accentCode,
              })},[_vm._v(" "+_vm._s(item)+" ")])})],2)]),_c('tbody',{style:({
            'background-color':
              _vm.$store.getters.getColorPalette().backgroundColorCode,
          })},_vm._l((_vm.dbData),function(item,ind){return _c('tr',{key:ind,style:({
              'background-color':
                _vm.$store.getters.getColorPalette().backgroundColorCode,
              color: _vm.$store.getters.getColorPalette().accentCode,
            })},[_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.period))])]),_c('td',{class:'pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.High))])]),_c('td',{class:'pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Medium))])]),_c('td',{class:'pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Low))])]),_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.NearMiss))])]),_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Reported))])]),_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Closed))])]),_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Open))])]),_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Reported > 0 ? (Number(item.Closed / item.Reported) * 100).toFixed(2) : 0)+"%")])]),_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Accident_Without_Loss))])]),_c('td',{class:' pa-1 text-center text-subtitle-2',style:({
                'background-color':
                  _vm.$store.getters.getColorPalette().background2ColorCode,
                color: _vm.$store.getters.getColorPalette().accentCode,
              })},[_c('span',[_vm._v(_vm._s(item.Aciddent_With_Loss))])])])}),0)]},proxy:true}],null,false,1715814562)})],1):_c('div',{style:([
      {
        padding: '10px',
        display: 'flex',
        'justify-content': 'center',
        color: _vm.$store.getters.getColorPalette().accentCode,
      },
    ])},[_c('v-icon',{staticClass:"mr-3",attrs:{"dark":_vm.$store.getters.getColorPalette().isDark}},[_vm._v("mdi-database-remove-outline")]),_c('h3',[_vm._v(_vm._s(_vm.$store.getters.getTextMap().no_data_available))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }